:root {
  --from-mobile: 26.5625em;
  --from-tablet: 40em;
  --from-desktop: 64em;
  --from-wide: 80em;
}

@media screen and (min-width: 64em) {
  .ai-wrapper {
    width: 800px;
  }
}
.ai-modal-header {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  padding-bottom: var(--fdt-core-spacing-3);
}

.ai-modal-center {
  display: flex;
  align-items: center;
  gap: 8px;
}

.ai-modal-title {
  margin: 0;
  font-weight: normal;
  text-align: center;
}

.ai-reset-button {
  position: absolute;
  right: 0;
}

.ai-color {
  color: var(--fdt-core-color-neutral-600) !important;
}

.ai-modal-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: 400px;
  padding-bottom: var(--fdt-core-spacing-3);
  box-sizing: border-box;
  text-align: center;
  overflow: hidden;
}
.ai-modal-content .ai-content-header {
  margin-bottom: var(--fdt-core-spacing-3);
}
.ai-modal-content .ai-tags {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--fdt-core-spacing-2);
}

.ai-intro-content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex-grow: 1;
  width: 100%;
  text-align: center;
}

.ai-conversation {
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  width: 100%;
  padding: 0 8px;
  gap: 10px;
  overflow-y: auto;
  text-align: left;
}

.ai-message {
  width: 90%;
  padding: 12px;
  border-radius: 18px;
  font-size: 16px;
  line-height: 1.4;
  word-wrap: break-word;
  font-weight: 400;
}

.ai-user-message {
  align-self: flex-end;
  background-color: var(--fdt-core-color-neutral-100);
  border-bottom-right-radius: 0;
  font-size: var(--fdt-core-body-p-normal-fontsize);
}

.ai-ai-message {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  align-self: flex-start;
  background-color: var(--fdt-core-color-primary-100);
  border-bottom-left-radius: 0;
  font-size: var(--fdt-core-body-p-small-fontsize);
  padding: 12px;
}
.ai-ai-message .ai-icon-panel {
  flex-shrink: 0;
  width: 32px;
  height: 32px;
  margin-right: 8px;
}
.ai-ai-message .ai-icon-panel .icon {
  width: 100%;
  height: 100%;
}
.ai-ai-message .ai-message-content {
  flex: 1;
  width: 50%;
}

.ai-modal-actions {
  display: flex;
  justify-content: center;
  margin-top: 16px;
  max-width: 100%;
}

.ai-modal-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  gap: 12px;
}
.ai-modal-footer .input-wrapper {
  width: 100%;
  max-width: 74%;
  min-width: 0;
}
.ai-modal-footer .input-wrapper .a-form-field {
  display: contents;
}
.ai-modal-footer .input-wrapper .input-with-unit {
  display: flex;
  flex: 1 1 auto;
  width: 100% !important;
  max-width: 100% !important;
}

@media screen and (max-width: 26.5em) {
  .ai-modal-footer {
    flex-direction: column;
  }
  .ai-modal-footer > * {
    flex: 1 1 0;
    width: 100%;
  }
  .ai-modal-footer .input-wrapper {
    flex: 1 1 auto;
    max-width: 100%;
  }
}
.ai-modal-divider {
  border: none;
  border-top: 1px solid var(--fdt-semantic-color-border-subtle);
  margin: 0 -24px 20px;
  width: auto;
  overflow: hidden;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */